export const RFQ_TYPES = [
  { value: 'STANDARD', label: 'Standard' },
  { value: 'URGENT', label: 'Urgent' },
  { value: 'RATE_CONTRACT', label: 'Rate Contract' },
  { value: 'EMERGENCY', label: 'Emergency' },
];

export const RFQ_STATUSES = [
  'DRAFT',
  'PUBLISHED',
  'CLOSED',
  'EVALUATED',
  'AWARDED',
  'CANCELLED',
];

/** Workflow stepper labels (main happy path) */
export const RFQ_WORKFLOW_STAGES = [
  { key: 'DRAFT', label: 'Draft' },
  { key: 'PUBLISHED', label: 'Published' },
  { key: 'CLOSED', label: 'Closed' },
  { key: 'AWARDED', label: 'Awarded' },
];

export const GST_RATE_OPTIONS = [
  { value: '0', label: '0%' },
  { value: '5', label: '5%' },
  { value: '12', label: '12%' },
  { value: '18', label: '18%' },
  { value: '28', label: '28%' },
];

/** Why an award went to someone other than the lowest quote. */
export const NON_L1_REASONS = [
  { value: 'QUALITY', label: 'Better product quality or brand' },
  { value: 'DELIVERY', label: 'Faster or more reliable delivery' },
  { value: 'PAST_PERFORMANCE', label: 'Better past performance' },
  { value: 'COMPLIANCE', label: 'L1 vendor has compliance issues' },
  { value: 'CAPACITY', label: 'L1 vendor cannot supply the full quantity' },
  { value: 'OTHER', label: 'Other — explained in remarks' },
];

export const MIN_AWARD_JUSTIFICATION_CHARS = 15;

export const DECLINE_REASONS = [
  { value: 'SPEC', label: 'Cannot meet the specification' },
  { value: 'QTY', label: 'Cannot supply the full quantity' },
  { value: 'DELIVERY', label: 'Cannot meet the delivery date' },
  { value: 'CAPACITY', label: 'No capacity on this timeline' },
  { value: 'CATEGORY', label: 'We do not bid on this category' },
  { value: 'OTHER', label: 'Other' },
];

export const VENDOR_CATEGORIES = [
  { value: 'Manufacturer', label: 'Manufacturer' },
  { value: 'Distributor', label: 'Distributor' },
  { value: 'Stockist', label: 'Stockist' },
  { value: 'Importer', label: 'Importer' },
  { value: 'Service provider', label: 'Service provider' },
];

/** Status labels a vendor is allowed to see. Internal codes never leak. */
export const VENDOR_FACING_QUOTE_STATUS = {
  DRAFT: 'Draft',
  SUBMITTED: 'Submitted',
  UNDER_EVALUATION: 'Under review',
  EVALUATED: 'Under review',
  ACCEPTED: 'Awarded',
  REJECTED: 'Not selected',
  WITHDRAWN: 'Withdrawn',
};

export const MAX_RFQ_ATTACHMENT_BYTES = 5 * 1024 * 1024;
export const ALLOWED_RFQ_ATTACHMENT_MIME = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/jpg',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

/** Must match the service's EvaluationStatus enum — it rejects anything else. */
export const QUOTE_EVALUATION_STATUSES = [
  { value: 'RECOMMENDED', label: 'Recommended' },
  { value: 'QUALIFIED', label: 'Qualified' },
  { value: 'DISQUALIFIED', label: 'Disqualified' },
];

/**
 * The service validates each weight as 0 < w <= 1, so neither side can be
 * zeroed out entirely.
 */
export const MIN_EVALUATION_WEIGHT_PCT = 5;
export const MAX_EVALUATION_WEIGHT_PCT = 95;
export const DEFAULT_TECHNICAL_WEIGHT_PCT = 40;
